export default {
      id: "project-type-multichat-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#project-type-multichat-usage",
      toString: function () {
        return this.url;
      }
    }